import { jsx as q, jsxs as ut } from "react/jsx-runtime";
import { c as Et } from "../index-Cu0xwYjD.js";
import v, { useState as pt, useRef as tt, useLayoutEffect as bt, useEffect as vt, useSyncExternalStore as kt, isValidElement as J, cloneElement as mt } from "react";
import { c as H } from "../clsx-OuTLNxxd.js";
import { Icon as G } from "./Icon.js";
import { Text as ht } from "./Text.js";
const et = (t) => typeof t == "number" && !isNaN(t), Y = (t) => typeof t == "string", x = (t) => typeof t == "function", rt = (t) => Y(t) || x(t) ? t : null, gt = (t) => J(t) || Y(t) || x(t) || et(t);
function xt(t, e, n) {
  n === void 0 && (n = 300);
  const { scrollHeight: a, style: o } = t;
  requestAnimationFrame(() => {
    o.minHeight = "initial", o.height = a + "px", o.transition = `all ${n}ms`, requestAnimationFrame(() => {
      o.height = "0", o.padding = "0", o.margin = "0", setTimeout(e, n);
    });
  });
}
function lt(t) {
  let { enter: e, exit: n, appendPosition: a = !1, collapse: o = !0, collapseDuration: c = 300 } = t;
  return function(s) {
    let { children: _, position: f, preventExitTransition: b, done: u, nodeRef: I, isIn: E, playToast: w } = s;
    const m = a ? `${e}--${f}` : e, d = a ? `${n}--${f}` : n, T = tt(0);
    return bt(() => {
      const p = I.current, l = m.split(" "), r = (g) => {
        g.target === I.current && (w(), p.removeEventListener("animationend", r), p.removeEventListener("animationcancel", r), T.current === 0 && g.type !== "animationcancel" && p.classList.remove(...l));
      };
      p.classList.add(...l), p.addEventListener("animationend", r), p.addEventListener("animationcancel", r);
    }, []), vt(() => {
      const p = I.current, l = () => {
        p.removeEventListener("animationend", l), o ? xt(p, u, c) : u();
      };
      E || (b ? l() : (T.current = 1, p.className += ` ${d}`, p.addEventListener("animationend", l)));
    }, [E]), v.createElement(v.Fragment, null, _);
  };
}
function _t(t, e) {
  return t != null ? { content: t.content, containerId: t.props.containerId, id: t.props.toastId, theme: t.props.theme, type: t.props.type, data: t.props.data || {}, isLoading: t.props.isLoading, icon: t.props.icon, status: e } : {};
}
const L = /* @__PURE__ */ new Map();
let st = [];
const yt = /* @__PURE__ */ new Set(), $t = (t) => yt.forEach((e) => e(t)), It = () => L.size > 0;
function Ct(t, e) {
  var n;
  if (e) return !((n = L.get(e)) == null || !n.isToastActive(t));
  let a = !1;
  return L.forEach((o) => {
    o.isToastActive(t) && (a = !0);
  }), a;
}
function wt(t, e) {
  gt(t) && (It() || st.push({ content: t, options: e }), L.forEach((n) => {
    n.buildToast(t, e);
  }));
}
function Tt(t, e) {
  L.forEach((n) => {
    e != null && e != null && e.containerId ? (e == null ? void 0 : e.containerId) === n.id && n.toggle(t, e == null ? void 0 : e.id) : n.toggle(t, e == null ? void 0 : e.id);
  });
}
function Pt(t) {
  const { subscribe: e, getSnapshot: n, setProps: a } = tt(function(c) {
    const s = c.containerId || 1;
    return { subscribe(_) {
      const f = /* @__PURE__ */ function(u, I, E) {
        let w = 1, m = 0, d = [], T = [], p = [], l = I;
        const r = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Set(), M = () => {
          p = Array.from(r.values()), g.forEach((i) => i());
        }, A = (i) => {
          T = i == null ? [] : T.filter((h) => h !== i), M();
        }, C = (i) => {
          const { toastId: h, onOpen: N, updateId: B, children: z } = i.props, j = B == null;
          i.staleId && r.delete(i.staleId), r.set(h, i), T = [...T, i.props.toastId].filter((R) => R !== i.staleId), M(), E(_t(i, j ? "added" : "updated")), j && x(N) && N(J(z) && z.props);
        };
        return { id: u, props: l, observe: (i) => (g.add(i), () => g.delete(i)), toggle: (i, h) => {
          r.forEach((N) => {
            h != null && h !== N.props.toastId || x(N.toggle) && N.toggle(i);
          });
        }, removeToast: A, toasts: r, clearQueue: () => {
          m -= d.length, d = [];
        }, buildToast: (i, h) => {
          if (((S) => {
            let { containerId: $, toastId: P, updateId: D } = S;
            const W = $ ? $ !== u : u !== 1, K = r.has(P) && D == null;
            return W || K;
          })(h)) return;
          const { toastId: N, updateId: B, data: z, staleId: j, delay: R } = h, Q = () => {
            A(N);
          }, nt = B == null;
          nt && m++;
          const O = { ...l, style: l.toastStyle, key: w++, ...Object.fromEntries(Object.entries(h).filter((S) => {
            let [$, P] = S;
            return P != null;
          })), toastId: N, updateId: B, data: z, closeToast: Q, isIn: !1, className: rt(h.className || l.toastClassName), bodyClassName: rt(h.bodyClassName || l.bodyClassName), progressClassName: rt(h.progressClassName || l.progressClassName), autoClose: !h.isLoading && (F = h.autoClose, U = l.autoClose, F === !1 || et(F) && F > 0 ? F : U), deleteToast() {
            const S = r.get(N), { onClose: $, children: P } = S.props;
            x($) && $(J(P) && P.props), E(_t(S, "removed")), r.delete(N), m--, m < 0 && (m = 0), d.length > 0 ? C(d.shift()) : M();
          } };
          var F, U;
          O.closeButton = l.closeButton, h.closeButton === !1 || gt(h.closeButton) ? O.closeButton = h.closeButton : h.closeButton === !0 && (O.closeButton = !gt(l.closeButton) || l.closeButton);
          let V = i;
          J(i) && !Y(i.type) ? V = mt(i, { closeToast: Q, toastProps: O, data: z }) : x(i) && (V = i({ closeToast: Q, toastProps: O, data: z }));
          const X = { content: V, props: O, staleId: j };
          l.limit && l.limit > 0 && m > l.limit && nt ? d.push(X) : et(R) ? setTimeout(() => {
            C(X);
          }, R) : C(X);
        }, setProps(i) {
          l = i;
        }, setToggle: (i, h) => {
          r.get(i).toggle = h;
        }, isToastActive: (i) => T.some((h) => h === i), getSnapshot: () => p };
      }(s, c, $t);
      L.set(s, f);
      const b = f.observe(_);
      return st.forEach((u) => wt(u.content, u.options)), st = [], () => {
        b(), L.delete(s);
      };
    }, setProps(_) {
      var f;
      (f = L.get(s)) == null || f.setProps(_);
    }, getSnapshot() {
      var _;
      return (_ = L.get(s)) == null ? void 0 : _.getSnapshot();
    } };
  }(t)).current;
  a(t);
  const o = kt(e, n, n);
  return { getToastToRender: function(c) {
    if (!o) return [];
    const s = /* @__PURE__ */ new Map();
    return t.newestOnTop && o.reverse(), o.forEach((_) => {
      const { position: f } = _.props;
      s.has(f) || s.set(f, []), s.get(f).push(_);
    }), Array.from(s, (_) => c(_[0], _[1]));
  }, isToastActive: Ct, count: o == null ? void 0 : o.length };
}
function Mt(t) {
  const [e, n] = pt(!1), [a, o] = pt(!1), c = tt(null), s = tt({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: _, pauseOnHover: f, closeToast: b, onClick: u, closeOnClick: I } = t;
  var E, w;
  function m() {
    n(!0);
  }
  function d() {
    n(!1);
  }
  function T(r) {
    const g = c.current;
    s.canDrag && g && (s.didMove = !0, e && d(), s.delta = t.draggableDirection === "x" ? r.clientX - s.start : r.clientY - s.start, s.start !== r.clientX && (s.canCloseOnClick = !1), g.style.transform = `translate3d(${t.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`},0)`, g.style.opacity = "" + (1 - Math.abs(s.delta / s.removalDistance)));
  }
  function p() {
    document.removeEventListener("pointermove", T), document.removeEventListener("pointerup", p);
    const r = c.current;
    if (s.canDrag && s.didMove && r) {
      if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) return o(!0), t.closeToast(), void t.collapseAll();
      r.style.transition = "transform 0.2s, opacity 0.2s", r.style.removeProperty("transform"), r.style.removeProperty("opacity");
    }
  }
  (w = L.get((E = { id: t.toastId, containerId: t.containerId, fn: n }).containerId || 1)) == null || w.setToggle(E.id, E.fn), vt(() => {
    if (t.pauseOnFocusLoss) return document.hasFocus() || d(), window.addEventListener("focus", m), window.addEventListener("blur", d), () => {
      window.removeEventListener("focus", m), window.removeEventListener("blur", d);
    };
  }, [t.pauseOnFocusLoss]);
  const l = { onPointerDown: function(r) {
    if (t.draggable === !0 || t.draggable === r.pointerType) {
      s.didMove = !1, document.addEventListener("pointermove", T), document.addEventListener("pointerup", p);
      const g = c.current;
      s.canCloseOnClick = !0, s.canDrag = !0, g.style.transition = "none", t.draggableDirection === "x" ? (s.start = r.clientX, s.removalDistance = g.offsetWidth * (t.draggablePercent / 100)) : (s.start = r.clientY, s.removalDistance = g.offsetHeight * (t.draggablePercent === 80 ? 1.5 * t.draggablePercent : t.draggablePercent) / 100);
    }
  }, onPointerUp: function(r) {
    const { top: g, bottom: M, left: A, right: C } = c.current.getBoundingClientRect();
    r.nativeEvent.type !== "touchend" && t.pauseOnHover && r.clientX >= A && r.clientX <= C && r.clientY >= g && r.clientY <= M ? d() : m();
  } };
  return _ && f && (l.onMouseEnter = d, t.stacked || (l.onMouseLeave = m)), I && (l.onClick = (r) => {
    u && u(r), s.canCloseOnClick && b();
  }), { playToast: m, pauseToast: d, isRunning: e, preventExitTransition: a, toastRef: c, eventHandlers: l };
}
function St(t) {
  let { delay: e, isRunning: n, closeToast: a, type: o = "default", hide: c, className: s, style: _, controlledProgress: f, progress: b, rtl: u, isIn: I, theme: E } = t;
  const w = c || f && b === 0, m = { ..._, animationDuration: `${e}ms`, animationPlayState: n ? "running" : "paused" };
  f && (m.transform = `scaleX(${b})`);
  const d = H("Toastify__progress-bar", f ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${E}`, `Toastify__progress-bar--${o}`, { "Toastify__progress-bar--rtl": u }), T = x(s) ? s({ rtl: u, type: o, defaultClassName: d }) : H(d, s), p = { [f && b >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: f && b < 1 ? null : () => {
    I && a();
  } };
  return v.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": w }, v.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${E} Toastify__progress-bar--${o}` }), v.createElement("div", { role: "progressbar", "aria-hidden": w ? "true" : "false", "aria-label": "notification timer", className: T, style: m, ...p }));
}
let Dt = 1;
const Lt = () => "" + Dt++;
function At(t) {
  return t && (Y(t.toastId) || et(t.toastId)) ? t.toastId : Lt();
}
function Z(t, e) {
  return wt(t, e), e.toastId;
}
function it(t, e) {
  return { ...e, type: e && e.type || t, toastId: At(e) };
}
function ot(t) {
  return (e, n) => Z(e, it(t, n));
}
function y(t, e) {
  return Z(t, it("default", e));
}
y.loading = (t, e) => Z(t, it("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...e })), y.promise = function(t, e, n) {
  let a, { pending: o, error: c, success: s } = e;
  o && (a = Y(o) ? y.loading(o, n) : y.loading(o.render, { ...n, ...o }));
  const _ = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, f = (u, I, E) => {
    if (I == null) return void y.dismiss(a);
    const w = { type: u, ..._, ...n, data: E }, m = Y(I) ? { render: I } : I;
    return a ? y.update(a, { ...w, ...m }) : y(m.render, { ...w, ...m }), E;
  }, b = x(t) ? t() : t;
  return b.then((u) => f("success", s, u)).catch((u) => f("error", c, u)), b;
}, y.success = ot("success"), y.info = ot("info"), y.error = ot("error"), y.warning = ot("warning"), y.warn = y.warning, y.dark = (t, e) => Z(t, it("default", { theme: "dark", ...e })), y.dismiss = function(t) {
  (function(e) {
    var n;
    if (It()) {
      if (e == null || Y(n = e) || et(n)) L.forEach((a) => {
        a.removeToast(e);
      });
      else if (e && ("containerId" in e || "id" in e)) {
        const a = L.get(e.containerId);
        a ? a.removeToast(e.id) : L.forEach((o) => {
          o.removeToast(e.id);
        });
      }
    } else st = st.filter((a) => e != null && a.options.toastId !== e);
  })(t);
}, y.clearWaitingQueue = function(t) {
  t === void 0 && (t = {}), L.forEach((e) => {
    !e.props.limit || t.containerId && e.id !== t.containerId || e.clearQueue();
  });
}, y.isActive = Ct, y.update = function(t, e) {
  e === void 0 && (e = {});
  const n = ((a, o) => {
    var c;
    let { containerId: s } = o;
    return (c = L.get(s || 1)) == null ? void 0 : c.toasts.get(a);
  })(t, e);
  if (n) {
    const { props: a, content: o } = n, c = { delay: 100, ...a, ...e, toastId: e.toastId || t, updateId: Lt() };
    c.toastId !== t && (c.staleId = t);
    const s = c.render || o;
    delete c.render, Z(s, c);
  }
}, y.done = (t) => {
  y.update(t, { progress: 1 });
}, y.onChange = function(t) {
  return yt.add(t), () => {
    yt.delete(t);
  };
}, y.play = (t) => Tt(!0, t), y.pause = (t) => Tt(!1, t);
const Bt = typeof window < "u" ? bt : vt, at = (t) => {
  let { theme: e, type: n, isLoading: a, ...o } = t;
  return v.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: e === "colored" ? "currentColor" : `var(--toastify-icon-color-${n})`, ...o });
}, ft = { info: function(t) {
  return v.createElement(at, { ...t }, v.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(t) {
  return v.createElement(at, { ...t }, v.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(t) {
  return v.createElement(at, { ...t }, v.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(t) {
  return v.createElement(at, { ...t }, v.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return v.createElement("div", { className: "Toastify__spinner" });
} }, Ot = (t) => {
  const { isRunning: e, preventExitTransition: n, toastRef: a, eventHandlers: o, playToast: c } = Mt(t), { closeButton: s, children: _, autoClose: f, onClick: b, type: u, hideProgressBar: I, closeToast: E, transition: w, position: m, className: d, style: T, bodyClassName: p, bodyStyle: l, progressClassName: r, progressStyle: g, updateId: M, role: A, progress: C, rtl: i, toastId: h, deleteToast: N, isIn: B, isLoading: z, closeOnClick: j, theme: R } = t, Q = H("Toastify__toast", `Toastify__toast-theme--${R}`, `Toastify__toast--${u}`, { "Toastify__toast--rtl": i }, { "Toastify__toast--close-on-click": j }), nt = x(d) ? d({ rtl: i, position: m, type: u, defaultClassName: Q }) : H(Q, d), O = function(X) {
    let { theme: S, type: $, isLoading: P, icon: D } = X, W = null;
    const K = { theme: S, type: $ };
    return D === !1 || (x(D) ? W = D({ ...K, isLoading: P }) : J(D) ? W = mt(D, K) : P ? W = ft.spinner() : ((Nt) => Nt in ft)($) && (W = ft[$](K))), W;
  }(t), F = !!C || !f, U = { closeToast: E, type: u, theme: R };
  let V = null;
  return s === !1 || (V = x(s) ? s(U) : J(s) ? mt(s, U) : function(X) {
    let { closeToast: S, theme: $, ariaLabel: P = "close" } = X;
    return v.createElement("button", { className: `Toastify__close-button Toastify__close-button--${$}`, type: "button", onClick: (D) => {
      D.stopPropagation(), S(D);
    }, "aria-label": P }, v.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, v.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
  }(U)), v.createElement(w, { isIn: B, done: N, position: m, preventExitTransition: n, nodeRef: a, playToast: c }, v.createElement("div", { id: h, onClick: b, "data-in": B, className: nt, ...o, style: T, ref: a }, v.createElement("div", { ...B && { role: A }, className: x(p) ? p({ type: u }) : H("Toastify__toast-body", p), style: l }, O != null && v.createElement("div", { className: H("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !z }) }, O), v.createElement("div", null, _)), V, v.createElement(St, { ...M && !F ? { key: `pb-${M}` } : {}, rtl: i, theme: R, delay: f, isRunning: e, isIn: B, closeToast: E, hide: I, type: u, style: g, className: r, controlledProgress: F, progress: C || 0 })));
}, ct = function(t, e) {
  return e === void 0 && (e = !1), { enter: `Toastify--animate Toastify__${t}-enter`, exit: `Toastify--animate Toastify__${t}-exit`, appendPosition: e };
}, zt = lt(ct("bounce", !0)), Rt = lt(ct("slide", !0));
lt(ct("zoom"));
lt(ct("flip"));
const Ft = { position: "top-right", transition: zt, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
function Ht(t) {
  let e = { ...Ft, ...t };
  const n = t.stacked, [a, o] = pt(!0), c = tt(null), { getToastToRender: s, isToastActive: _, count: f } = Pt(e), { className: b, style: u, rtl: I, containerId: E } = e;
  function w(d) {
    const T = H("Toastify__toast-container", `Toastify__toast-container--${d}`, { "Toastify__toast-container--rtl": I });
    return x(b) ? b({ position: d, rtl: I, defaultClassName: T }) : H(T, rt(b));
  }
  function m() {
    n && (o(!0), y.play());
  }
  return Bt(() => {
    if (n) {
      var d;
      const T = c.current.querySelectorAll('[data-in="true"]'), p = 12, l = (d = e.position) == null ? void 0 : d.includes("top");
      let r = 0, g = 0;
      Array.from(T).reverse().forEach((M, A) => {
        const C = M;
        C.classList.add("Toastify__toast--stacked"), A > 0 && (C.dataset.collapsed = `${a}`), C.dataset.pos || (C.dataset.pos = l ? "top" : "bot");
        const i = r * (a ? 0.2 : 1) + (a ? 0 : p * A);
        C.style.setProperty("--y", `${l ? i : -1 * i}px`), C.style.setProperty("--g", `${p}`), C.style.setProperty("--s", "" + (1 - (a ? g : 0))), r += C.offsetHeight, g += 0.025;
      });
    }
  }, [a, f, n]), v.createElement("div", { ref: c, className: "Toastify", id: E, onMouseEnter: () => {
    n && (o(!1), y.pause());
  }, onMouseLeave: m }, s((d, T) => {
    const p = T.length ? { ...u } : { ...u, pointerEvents: "none" };
    return v.createElement("div", { className: w(d), style: p, key: `container-${d}` }, T.map((l) => {
      let { content: r, props: g } = l;
      return v.createElement(Ot, { ...g, stacked: n, collapseAll: m, isIn: _(g.toastId, g.containerId), style: g.style, key: `toast-${g.key}` }, r);
    }));
  }));
}
const Xt = "_snackbarContainer_1wavi_1", Wt = "_toastLink_1wavi_4", qt = "_Toastify__toast_1wavi_8", Yt = "_toast_1wavi_4", jt = "_toastSuccess_1wavi_24", Qt = "_toastError_1wavi_28", Ut = "_toastInfo_1wavi_32", Vt = "_toastWarning_1wavi_36", Gt = "_toastClose_1wavi_40", Jt = "_toastInner_1wavi_49", Kt = "_toastMessage_1wavi_57", Zt = "_toastText_1wavi_63", te = "_hasDescription_1wavi_94", k = {
  snackbarContainer: Xt,
  toastLink: Wt,
  "Toastify__toast-body": "_Toastify__toast-body_1wavi_8",
  Toastify__toast: qt,
  toast: Yt,
  toastSuccess: jt,
  toastError: Qt,
  toastInfo: Ut,
  toastWarning: Vt,
  toastClose: Gt,
  toastInner: Jt,
  toastMessage: Kt,
  toastText: Zt,
  hasDescription: te
}, pe = () => /* @__PURE__ */ q(
  Ht,
  {
    position: "bottom-left",
    autoClose: 5e3,
    hideProgressBar: !0,
    transition: Rt,
    className: k.snackbarContainer,
    icon: !1,
    closeButton: !1
  }
), ee = (t) => {
  dt({ ...t, type: "success" });
}, se = (t) => {
  dt({ ...t, type: "error" });
}, ne = (t) => {
  dt({ ...t, type: "info" });
}, oe = (t) => {
  dt({ ...t, type: "warning" });
}, dt = ({
  message: t,
  type: e,
  description: n,
  id: a,
  link: o
}) => {
  const c = (() => {
    switch (e) {
      case "success":
        return G.statusSuccessFilledTransparent;
      case "error":
        return G.statusAlertFilledTransparent;
      case "info":
        return G.statusInfoFilledTransparent;
      case "warning":
        return G.statusCautionFilledTransparent;
      default:
        return G.statusSuccessFilledTransparent;
    }
  })();
  y(
    ({ ...s }) => /* @__PURE__ */ q(
      re,
      {
        message: t,
        description: n,
        ...s,
        icon: c,
        link: o
      }
    ),
    {
      type: e,
      toastId: a,
      className: Et(k.toast, {
        [k.toastSuccess]: e === "success",
        [k.toastError]: e === "error",
        [k.toastInfo]: e === "info",
        [k.toastWarning]: e === "warning"
      })
    }
  );
}, ae = ({ id: t }) => {
  y.dismiss(t);
}, re = ({
  message: t,
  closeToast: e,
  description: n,
  icon: a,
  link: o
}) => /* @__PURE__ */ ut(
  "div",
  {
    className: Et(
      k.toastInner,
      n && k.hasDescription
    ),
    children: [
      /* @__PURE__ */ ut("div", { className: k.toastMessage, children: [
        /* @__PURE__ */ q("div", { className: k.toastIcon, children: a }),
        /* @__PURE__ */ ut("div", { className: k.toastText, children: [
          /* @__PURE__ */ q(ht, { size: "14px", weight: "600", children: t }),
          n && /* @__PURE__ */ q(ht, { size: "12px", weight: "400", children: n })
        ] }),
        o && /* @__PURE__ */ q("a", { href: o.href, className: k.toastLink, children: o.label })
      ] }),
      /* @__PURE__ */ q("button", { onClick: e, className: k.toastClose, children: G.close })
    ]
  }
), me = {
  successToast: ee,
  errorToast: se,
  infoToast: ne,
  warningToast: oe,
  dismissToast: ae
};
export {
  re as Notification,
  me as Snackbar,
  pe as SnackbarContainer,
  ae as dismissToast
};
